import * as tslib_1 from "tslib";
// Core packages
import { formatDate } from '@angular/common';
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
// Third party packages
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from "file-saver";
import { default as moment } from 'moment';
import { ToastrService } from "ngx-toastr";
import { combineLatest, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, startWith, take, tap } from 'rxjs/operators';
// Core packages
import { MatDialog } from '@angular/material';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { DeadlinesService } from 'src/app/modules/deadlines/deadlines.service';
import { CancelContractDialogComponent } from "src/app/modules/properties/components/cancel-contract-dialog/cancel-contract-dialog.component";
import { PropertyExpireContractItemDialogComponent } from "src/app/modules/properties/components/contract-expire-item-dialog/contract-expire-item-dialog.component";
import { DocumentDownloadDialogComponent } from 'src/app/modules/properties/components/document-download-dialog/document-download-dialog.component';
import { PropertyDetailDocumentItemDialogComponent } from 'src/app/modules/properties/components/document-item-dialog/document-item-dialog.component';
import { PropertyDetailDocumentItemPrintDialogComponent } from "src/app/modules/properties/components/document-item-print-dialog/document-item-print-dialog.component";
import { PropertyDetailDocumentPrintModuleDialogComponent } from "src/app/modules/properties/components/document-print-module-dialog/document-print-module-dialog.component";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import DocumentTypeStructure from 'src/app/modules/properties/documentTypes';
import { PropertiesService } from 'src/app/modules/properties/properties.service';
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SuppliersService } from 'src/app/modules/suppliers/suppliers.service';
import { Company } from "src/app/shared/models/company/company.model";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from 'src/app/shared/services/helper.service';
import { ListsService } from 'src/app/shared/services/lists.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { DeadlinesDataSource } from 'src/app/shared/utils/data-sources/deadlines-data-source';
import { PropertyDeleteDocumentItemDialogComponent } from "../../../properties/components/document-delete-item-dialog/document-delete-item-dialog.component";
import { BalanceListDialogComponent } from '../../components/balances-list-dialog/balances-list-dialog.component';
var DocumentsDeadlinesListComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function DocumentsDeadlinesListComponent(dialog, cancelContractDialog, deadlinesService, helperService, authService, translateService, themeService, listsService, propertiesService, configService, suppliersService, settingsService, companiesService, condoStructuresService, toastrService, documentArchivesService) {
        this.dialog = dialog;
        this.cancelContractDialog = cancelContractDialog;
        this.deadlinesService = deadlinesService;
        this.helperService = helperService;
        this.authService = authService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.listsService = listsService;
        this.propertiesService = propertiesService;
        this.configService = configService;
        this.suppliersService = suppliersService;
        this.settingsService = settingsService;
        this.companiesService = companiesService;
        this.condoStructuresService = condoStructuresService;
        this.toastrService = toastrService;
        this.documentArchivesService = documentArchivesService;
        this.subscriptions = [];
        // BEGIN - Table deadlines
        this.displayedColumns = ['index', 'property', 'masterCode', 'structureObjectName', 'document', 'providerName', 'memoTime', 'renewalType', 'endDate', 'actions'];
        // @ViewChild('input', { static: true }) input: ElementRef;
        this.propertyFilter = new FormControl('');
        this.masterCodeFilter = new FormControl('');
        // areaFilter: FormControl = new FormControl('');
        this.structureObjectNameFilter = new FormControl('');
        this.providerNameFilter = new FormControl('');
        this.documentFilter = new FormControl('');
        this.endDateFilter = new FormControl(moment().startOf('day'));
        this.memoTimeFilter = new FormControl('');
        this.renewalTypeFilter = new FormControl('');
        this.propertyIsLoading = false;
        this.availableProperties = [];
        this.availableTypes = [];
        this.documentTypeStructure = new DocumentTypeStructure();
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.loggedUserMaster = false;
        this.companyData = {};
        this.company = new Company();
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant('deadlines.documentsList.pageTitle'));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser = res; }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return _this.loggedUserPermissions = res; }));
        // Get logged user's role data
        this.currentRole = this.loggedUser.userRoles.find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        this.loggedUserRole = this.currentRole.role;
        if (this.currentRole.role.type === "master" ||
            this.currentRole.role.type === "collaborator") {
            this.loggedUserMaster = true;
            if (this.currentRole.company._id !== "") {
                this.subscriptions.push(this.companiesService
                    .get(this.currentRole.company._id)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.companyData = res.data;
                        _this.company.setData(res.data);
                    }
                }));
            }
        }
        // Init data source
        this.dataSource = new DeadlinesDataSource(this.deadlinesService, this.helperService, this.translateService);
        // Init areas
        this.availableTypes = this.configService.availableDocumentAreas
            .map(function (element) {
            return {
                value: element,
                label: _this.translateService.instant("properties.documents.areas." + element),
            };
        });
        this.subscriptions.push(this.settingsService.getDocument().subscribe(function (res) {
            if (res.status) {
                if (res.data &&
                    Array.isArray(res.data) &&
                    res.data.length > 0 &&
                    res.data[0].area &&
                    Array.isArray(res.data[0].area)) {
                    _this.documentTemplateId = res.data[0]._id;
                    _this.documentTemplate = res.data[0].area;
                }
            }
        }, function (err) {
            //
        }));
        // Subscribe to listsService and update this list settings
        this.subscribeToListsSettings('deadlines');
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Load first set of data
        this.loadPage();
        // Reset pagination after sorting
        this.subscriptions.push(this.sort.sortChange.subscribe(function () { return _this.paginator.pageIndex = 0; }));
        // Once user change sorting OR change page
        // let's reload the page data
        this.subscriptions.push(merge(this.sort.sortChange, this.paginator.page)
            .pipe(tap(function () { return _this.loadPage(); }))
            .subscribe());
        // Handle server-side filtering through general search
        // this.subscriptions.push(
        //   fromEvent(this.input.nativeElement, 'keyup')
        //     .pipe(
        //       debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        //       distinctUntilChanged(), // Eliminate duplicate values
        //       tap(() => {
        //         this.paginator.pageIndex = 0; // Reset page
        //         this.loadPage();
        //       })
        //     )
        //     .subscribe()
        // );
        // Handle server-side filtering through column-specific search
        // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
        this.subscriptions.push(combineLatest([
            this.propertyFilter.valueChanges.pipe(startWith(null)),
            this.masterCodeFilter.valueChanges.pipe(startWith(null)),
            this.documentFilter.valueChanges.pipe(startWith(null)),
            this.endDateFilter.valueChanges.pipe(startWith(null)),
            this.memoTimeFilter.valueChanges.pipe(startWith(null)),
            this.renewalTypeFilter.valueChanges.pipe(startWith(null)),
            this.structureObjectNameFilter.valueChanges.pipe(startWith(null)),
            this.providerNameFilter.valueChanges.pipe(startWith(null)),
        ])
            .pipe(debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        distinctUntilChanged())
            .subscribe(function (res) {
            // Handle property filter
            if (res) {
                _this.propertyIsLoading = true;
                _this.getAvailableProperties({
                    general: _this.propertyFilter.value
                });
            }
            // Load page only if at least one value is not null
            if (!res.every(function (value) { return value === null; })) {
                _this.paginator.pageIndex = 0;
                _this.loadPage();
            }
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all deadlines
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        // Push current list settings to the listsService
        this.listsService.setListSetting('deadlines', this.paginator.pageIndex.valueOf(), this.paginator.pageSize.valueOf(), {
            general: '',
            property: this.propertyFilter.value,
            masterCode: this.masterCodeFilter.value,
            // area: this.areaFilter.value,
            structureObjectName: this.structureObjectNameFilter.value,
            providerName: this.providerNameFilter.value,
            document: this.documentFilter.value,
            endDate: this.endDateFilter.value,
            memoTime: this.memoTimeFilter.value,
            renewalType: this.renewalTypeFilter.value,
        });
    };
    /**
     * Load requested data page
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.loadPage = function () {
        var start = this.paginator.pageIndex * this.paginator.pageSize;
        var length = this.paginator.pageSize;
        var search = {
            general: '',
            property: this.propertyFilter.value ? this.propertyFilter.value._id : undefined,
            masterCode: this.masterCodeFilter.value,
            // area: this.areaFilter.value,
            structureObjectName: this.structureObjectNameFilter.value,
            providerName: this.providerNameFilter.value,
            document: this.documentFilter.value,
            endDate: this.endDateFilter.value ? new Date(this.endDateFilter.value).toISOString() : undefined,
            memoTime: this.memoTimeFilter.value,
            renewalType: this.renewalTypeFilter.value,
        };
        this.dataSource.loadDocumentsItems(start, length, this.sort.active, this.sort.direction, search);
    };
    /**
     * Export deadlines in a file with given format
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onExport = function () {
        var _this = this;
        var date = formatDate(new Date(), 'yyyyMMddhhmmss', 'en-EN');
        var fileName = this.translateService.instant('deadlines.documentsList.exportFileName') + " " + date;
        this.subscriptions.push(this.deadlinesService.getDocumentsExport().subscribe(function (res) {
            var fileBlob = res;
            var blob = new Blob([fileBlob], {
                type: 'application/vnd.ms-excel'
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Reset table's filters
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onResetFilters = function () {
        // Reset lists service data
        this.listsService.setListSetting('deadlines', 0, 10, {});
        // Reset tables' filters
        // this.input.nativeElement.value = '';
        this.propertyFilter.setValue(null);
        this.masterCodeFilter.setValue(null);
        // this.areaFilter.setValue(null);
        this.structureObjectNameFilter.setValue(null);
        this.providerNameFilter.setValue(null);
        this.documentFilter.setValue(null);
        this.endDateFilter.setValue(moment().startOf('day'));
        this.memoTimeFilter.setValue(null);
        this.renewalTypeFilter.setValue(null);
        // Reset tables' sorting versus and column
        this.sort.direction = "asc";
        this.sort.active = "endDate";
        this.sort._stateChanges.next();
        // Reset paginator
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 10;
        // Reload table's data
        this.loadPage();
    };
    /**
     * Reset given filter value and reload the page
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onResetFilter = function (filter) {
        filter.reset();
        this.loadPage();
    };
    /**
     * Subscribe to lists settings service to allow this list
     * to remember current filters once users navigate to another page.
     * In this way once user will come back to this page he will
     * have all previous settings (such as page number, page size, search, ...)
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.subscribeToListsSettings = function (name) {
        var _this = this;
        this.listsService.enable();
        this.subscriptions.push(this.listsService.listsSettings$.subscribe(function (settings) {
            if (settings.length) {
                settings.forEach(function (setting) {
                    if (setting.name === name) {
                        if (setting.pageIndex) {
                            _this.paginator.pageIndex = setting.pageIndex;
                        }
                        if (setting.pageSize) {
                            _this.paginator.pageSize = setting.pageSize;
                        }
                        if (setting.search && setting.search.general) {
                            // this.input.nativeElement.value = setting.search.general;
                        }
                        if (setting.search && setting.search.property) {
                            _this.propertyFilter.setValue(setting.search.property);
                        }
                        if (setting.search && setting.search.masterCode) {
                            _this.masterCodeFilter.setValue(setting.search.masterCode);
                        }
                        // if (setting.search && setting.search.area) {
                        //   this.areaFilter.setValue(setting.search.area);
                        // }
                        if (setting.search && setting.search.structureObjectName) {
                            _this.structureObjectNameFilter.setValue(setting.search.structureObjectName);
                        }
                        if (setting.search && setting.search.providerName) {
                            _this.providerNameFilter.setValue(setting.search.providerName);
                        }
                        if (setting.search && setting.search.document) {
                            _this.documentFilter.setValue(setting.search.document);
                        }
                        if (setting.search && setting.search.date) {
                            _this.endDateFilter.setValue(setting.search.date);
                        }
                        if (setting.search && setting.search.memoTime) {
                            _this.memoTimeFilter.setValue(setting.search.memoTime);
                        }
                        if (setting.search && setting.search.renewalType) {
                            _this.renewalTypeFilter.setValue(setting.search.renewalType);
                        }
                    }
                });
            }
        }));
    };
    /**
     * Reset general search input and dispath a 'keyup' event
     * so that the table re-render his rows
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.resetInput = function () {
        // this.input.nativeElement.value = '';
        var event = new KeyboardEvent('keyup');
        // this.input.nativeElement.dispatchEvent(event);
    };
    /**
     * Get the list of available admins and owners
     * used to allow filtering on owner and admin columns
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.getAvailableProperties = function (search) {
        var _this = this;
        this.subscriptions.push(this.propertiesService
            .getList(0, null, null, null, search)
            .pipe(finalize(function () {
            _this.propertyIsLoading = false;
        }))
            .subscribe(function (res) {
            if (res.status) {
                _this.availableProperties = res.data.items;
            }
        }));
    };
    /**
     * Used to handle the display of selected result
     *
     * @since 1.0.0
     *
     * @param arg Data to be displayed
     * @returns result string to display or undefined
     */
    DocumentsDeadlinesListComponent.prototype.displayFn = function (arg) {
        return arg ? "" + arg.name : undefined;
    };
    /**
     * Handle click on a selected property in the mat-autocomplete list and fires the loadPage()
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onPropertyFilterSelected = function (event) {
        var value = event.source.value;
        this.propertyFilter.setValue(value, { emitEvent: false });
        this.loadPage();
    };
    /**
     * Handle click on "Open" button next to each item
     * and open a view dialog for clicked element
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onOpenDialog = function (element) {
        var _this = this;
        if (!element) {
            return;
        }
        // Open dialog
        var dialogRef = this.dialog.open(BalanceListDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                element: element,
                propertyId: element._id,
            }
        });
        // On dialog closing, check if something is changed
        // If so, let's reload table data
        this.subscriptions.push(dialogRef.afterClosed()
            .subscribe(function (res) {
            if (res) {
                _this.loadPage();
                return;
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Handle click on document and open dialog box to edit/show document data
     *
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     * action: edit or show doc data
     * documentFather:
     * area:
     * structureId: related structure Id
     * expired:
     * contractPdfMsg:
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onToggleEditShowDocument = function (modalTitle, documentKey, documentId, subDocumentId, itemData, action, documentArchiveId, propertyData, documentFather, keyTranslateTitle, area, structureId, expired, contractPdfMsg, cancellationRequestDate, cancellationRequestBy) {
        var _this = this;
        if (structureId === '') {
            structureId = undefined;
        }
        // Create formly default fields
        var defaultFields = [
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "contenutoDocumento",
                templateOptions: {
                    label: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    required: true,
                    minLength: 2,
                    maxLength: 500,
                    rows: 5,
                    disabled: action === "show" ? true : false,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "input",
                key: "protocollo",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    required: false,
                    minLength: 0,
                    maxLength: 500,
                    disabled: action === "show" ? true : false,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "keyword",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    required: false,
                    minLength: 0,
                    maxLength: 1000,
                    rows: 3,
                    disabled: action === "show" ? true : false,
                },
            }
        ];
        // create fields formly from document key: es AA1
        // const aryfields = this.documentTypeStructure.getFormlyFields(
        //   documentKey,
        //   false
        // );
        var schemaType = JSON.parse(JSON.stringify(this.documentTypeStructure.getDocumentType2(documentKey, this.documentTemplate)));
        var aryfields = this.documentTypeStructure.getFormlyFields2(schemaType, false);
        aryfields.forEach(function (item) {
            if (item.templateOptions && item.templateOptions.placeholder) {
                item.templateOptions.placeholder = _this.translateService.instant(item.templateOptions.placeholder);
            }
            if (item.type === "select") {
                if (Array.isArray(item.templateOptions.options)) {
                    item.templateOptions.options.forEach(function (subItem) {
                        subItem.label = _this.translateService.instant(subItem.label);
                    });
                }
            }
            if (item.type === "selectNew") {
                item.type = "autocomplete";
                if (item.templateOptions.initialValues) {
                    var options_1 = [];
                    switch (item.templateOptions.initialValues) {
                        case "suppliersName":
                            _this.suppliersName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "yearsOfStorage":
                            _this.yearsOfStorage.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "conductorName":
                            _this.conductorName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "nameInterventionArchiving":
                            _this.nameInterventionArchiving.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                    }
                    item.templateOptions.initialValues = options_1;
                    item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                    item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                }
            }
            if (item.type === "autocomplete" ||
                item.type === "autocomplete-supplier") {
                item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                if (item.templateOptions.search$ === "suppliersService") {
                    item.templateOptions.search$ =
                        _this.suppliersService.getListV2.bind(_this);
                }
            }
            else {
                if (item.templateOptions && item.templateOptions.label) {
                    item.templateOptions.label = _this.translateService.instant(item.templateOptions.label);
                }
            }
            if (action === "show" && item.templateOptions) {
                item.templateOptions.disabled = true;
            }
        });
        // const contract = this.documentTypeStructure.isContract(documentKey);
        var contract = this.documentTypeStructure.isContract2(documentKey, this.documentTemplate);
        var fieldGroup = aryfields.concat(defaultFields);
        var itemConfig = [
            {
                fieldGroupClassName: "row",
                fieldGroup: fieldGroup,
            },
        ];
        var propertyCode = propertyData.code;
        var companyCode = this.company.get("code");
        var barCode = "";
        if (itemData && itemData.barCode) {
            barCode = itemData.barCode;
        }
        var selectedArea = 0;
        if (area) {
            switch (area) {
                case "amministrativo":
                    selectedArea = 1;
                    break;
                case "contratti":
                    selectedArea = 2;
                    break;
                case "tecnico":
                    selectedArea = 3;
                    break;
                case "unitaImmobiliari":
                    selectedArea = 4;
                    break;
            }
        }
        var title;
        if (keyTranslateTitle) {
            title = keyTranslateTitle.split("properties.documents.")[1];
        }
        if (itemData && cancellationRequestBy) {
            itemData.cancellationRequestDate = cancellationRequestDate;
            itemData.cancellationRequestBy = cancellationRequestBy;
        }
        // this.structureSelected = this.structureSelected.find(el => el.id === structureId);
        var dialogRef = this.dialog.open(PropertyDetailDocumentItemDialogComponent, {
            data: {
                modalTitle: modalTitle,
                documentArchiveId: documentArchiveId,
                documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
                documentId: documentId,
                documentKey: documentKey,
                subDocumentId: subDocumentId,
                itemData: itemData,
                itemConfig: itemConfig,
                propertyCode: propertyCode,
                companyCode: companyCode,
                barCode: barCode,
                action: action,
                documentFather: documentFather,
                keyTranslateTitle: title,
                structureId: structureId,
                contract: contract,
                expired: expired,
                contractPdfMsg: contractPdfMsg,
                selectedArea: selectedArea,
                property: propertyData,
                companyData: this.loggedUserMaster ? this.companyData : "",
                propertyName: propertyData.name,
            },
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.loadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle click on document form to download file
     * itemData: data value of form items
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onToggleDownloadDocument = function (propertyId, documents) {
        var _this = this;
        if (!documents || !documents.length) {
            return;
        }
        var dialogRef = this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                propertyId: propertyId,
                documents: documents,
            },
            width: "600px"
        });
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // Reload page after dialog closed
                _this.loadPage();
            }
        });
    };
    /**
     * Handle click on document form to delete document
     * documentArchiveId: Id of the document archive
     * itemData: data value of the document
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onToggleDeleteDocument = function (documentArchiveId, itemData) {
        var _this = this;
        var dialogRef = this.dialog.open(PropertyDeleteDocumentItemDialogComponent, {
            data: {
                documentArchiveId: documentArchiveId,
                barCode: itemData.barCode ? itemData.barCode : '',
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                _this.loadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle click on document form to print file
     * area: document area
     * topic: document topic
     * type: document type
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onTogglePrintDocument = function (subArea, area, topic, structure, modalTitle, documentKey, documentId, subDocumentId, itemData, propertyData, documentArchiveId) {
        var propertyCode = propertyData.code;
        var areaNumber = "0";
        if (subArea) {
            switch (subArea) {
                case "amministrativo":
                    areaNumber = "1";
                    break;
                case "contratti":
                    areaNumber = "2";
                    break;
                case "tecnico":
                    areaNumber = "3";
                    break;
                case "unitaImmobiliari":
                    areaNumber = "4";
                    break;
            }
        }
        var selectedArea = this.documentTypeStructure.getDocumentArea2(areaNumber, this.documentTemplate);
        var barCode = "";
        if (itemData && itemData.barCode) {
            barCode = itemData.barCode;
        }
        var name = propertyData.name;
        var city = propertyData.address.city;
        var address = propertyData.address.route + " " + propertyData.address.streetNumber;
        this.dialog.open(PropertyDetailDocumentItemPrintDialogComponent, {
            data: {
                modalTitle: modalTitle,
                documentArchiveId: documentArchiveId,
                documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
                documentId: documentId,
                documentKey: documentKey,
                subDocumentId: subDocumentId,
                itemData: itemData,
                propertyCode: propertyCode,
                barCode: barCode,
                name: name,
                city: city,
                address: address,
                area: area,
                topic: this.translateService.instant("properties.documents." + topic),
                structure: structure,
                subArea: selectedArea && selectedArea.title ? selectedArea.title : "",
            },
            width: "700px",
        });
    };
    /**
     * Handle click on document form to print nodule
     * area: document area
     * topic: document topic
     * type: document type
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onTogglePrintModuleDoc = function (subArea, subTopic, structure, modalTitle, itemData, property) {
        var areaNumber = "0";
        if (subArea) {
            switch (subArea) {
                case "amministrativo":
                    areaNumber = "1";
                    break;
                case "contratti":
                    areaNumber = "2";
                    break;
                case "tecnico":
                    areaNumber = "3";
                    break;
                case "unitaImmobiliari":
                    areaNumber = "4";
                    break;
            }
        }
        var selectedArea = this.documentTypeStructure.getDocumentArea2(areaNumber, this.documentTemplate);
        this.dialog.open(PropertyDetailDocumentPrintModuleDialogComponent, {
            data: {
                modalTitle: modalTitle,
                itemData: itemData,
                property: property,
                area: selectedArea && selectedArea.title ? selectedArea.title : "",
                docs: [{ title: modalTitle, subDoc: subTopic }],
                structure: structure ? [{ name: structure }] : [],
            },
            width: "700px",
        });
    };
    /**
     * Handle click on document form to delete file
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     * action: edito or show doc data
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onCancelContractDialogOpen = function (subTopic, modalTitle, structureId, documentKey, documentId, subDocumentId, itemData, property, documentArchiveId) {
        var _this = this;
        var contract = tslib_1.__assign({}, itemData, { documentArchiveId: documentArchiveId, title: modalTitle, companyData: this.loggedUserMaster ? this.companyData : "", propertyName: property.ame, propertyId: property._id });
        // Open dialog
        var dialogRef = this.cancelContractDialog.open(CancelContractDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                contract: contract,
                subject: this.translateService.instant("communications.fields.cancelContractSubject"),
                body: this.translateService.instant("communications.fields.cancelContractImmediateBody", { title: modalTitle.trim() }),
            },
            disableClose: true,
        });
        // On dialog closing, let's update model
        this.subscriptions.push(dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                var sendData = {
                    msg: res,
                };
                _this.subscriptions.push(_this.documentArchivesService
                    .cancelContract(documentArchiveId, sendData)
                    .pipe(take(1))
                    .subscribe(function (res) {
                    if (!res) {
                        return;
                    }
                    else {
                        // recreate view of all docs to show new inserted doc
                        _this.loadPage();
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                }));
            }
            else {
                // console.warn("TASTO CHIUDI")
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Handle click on document form to expire contract
     * documentArchiveId: Id of the document archive
     * itemData: data value of the document
     *
     * @since 1.0.0
     */
    DocumentsDeadlinesListComponent.prototype.onHandleExpiredContract = function (documentArchiveId, itemData) {
        var _this = this;
        var dialogRef = this.dialog.open(PropertyExpireContractItemDialogComponent, {
            data: {
                documentArchiveId: documentArchiveId,
                barCode: itemData.barCode ? itemData.barCode : '',
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.loadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    return DocumentsDeadlinesListComponent;
}());
export { DocumentsDeadlinesListComponent };
